import { httpClient , setResponseType } from '@/app/shared/services';
import { apiConstants } from '../config';
import { parkingsMock } from '../../../../assets/mocks/parkings.mock';

const PRODUCT_TYPES = [
  { key: 'pre_paid', value: 'parkings_plans_clients', label: 'Planes Prepago', element: 'Plan Prepago'},
  { key: 'base', value: 'parkings_plans_clients_per_minutes', label: 'Planes Base (por minuto)', element: 'Plan Base'},
  { key: 'custom',  value: 'parkings_plans_clients_customs', label: 'Planes Personalizados', element: 'Plan Personalizados'},
  { key: 'trial', value: 'parkings_plans_clients_trials', label: 'Períodos de prueba', element: 'Período de Prueba'},
]

const URL = apiConstants.plan;
const PARKINGS_PLAN_URL = apiConstants.parkingPlan;
const PARKINGS_PLAN_PRODUCT = apiConstants.parkingProduct;
// PLAN

const fetchAllPlans = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${URL}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${URL}?${filter}`).then(res => res.data)
  }
};
// Viejo endpoint
const fetchOnePlan = (id) => {
  return httpClient.get(`${URL}/${id}`).then(res => res.data);
};
// Nuevos endpoints
const fetchOnePlanClient = (id) => {
  return httpClient.get(`${PARKINGS_PLAN_PRODUCT}/${id}`).then(res => res.data);
}

const fetchOnePlanClientCustom = (id) => {
  return httpClient.get(`${PARKINGS_PLAN_PRODUCT}-custom/${id}`).then(res => res.data);
}

const fetchOnePlanClientPerMinute = (id) => {
  return httpClient.get(`${PARKINGS_PLAN_PRODUCT}-per-minutes/${id}`).then(res => res.data);
}

const fetchOnePlanClientExtras = (id) => {
  return httpClient.get(`${PARKINGS_PLAN_PRODUCT}-extras/${id}`).then(res => res.data);
}

const searchPlans = (filtro) => {
  const data = parkingsMock;
  return data;
}

const downloadExcel = (filename) => {
  setResponseType('blob');
  return httpClient.post(`${URL}/to-excel`, {name: filename}).then(res => {
    setResponseType('json');
    return res
  });
};

const resetResponseType = () => {
  setResponseType('json');
};


export {
  fetchAllPlans,
  fetchOnePlan,
  searchPlans,
  downloadExcel,
  resetResponseType,
  fetchOnePlanClient,
  fetchOnePlanClientCustom,
  fetchOnePlanClientPerMinute,
  fetchOnePlanClientExtras,
};
